import type { CustomerStatus } from '@oscom/shared';

/**
 * German display labels for `CustomerStatus`.
 *
 * Shared by `CustomersPage` (table column) and `CustomerDetailPage` (status
 * select) so a status rename only has to happen in one place.
 */
export const CUSTOMER_STATUS_LABELS: Record<CustomerStatus, string> = {
  prospect: 'Interessent',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  archived: 'Archiviert',
};
